<template>
  <base-material-card
    :icon="icon"
    class="v-card--material-stats jp-card"
    v-bind="$attrs"
    style="min-height: 140px!important"
    v-on="$listeners"
  >
    <template v-slot:after-heading>
      <div class="ml-auto text-right">
        <div
          class="body-2 grey--text font-weight-light"
          style="font-size: 18px!important; color: #858585!important; font-weight: 400!important;"
          v-text="title"
        />

        <h3
          class="jp-value-text display-2 font-weight-light text--primary"
          :style="
            (valueSize ? `font-size: ${valueSize}!important; ` : '') +
              (valueWeight ? `font-weight: ${valueWeight}!important; ` : '') +
              (valueColor ? `color: ${valueColor}!important; ` : '')
          "
        >
          {{ value }} <small>{{ smallValue }}</small>
        </h3>
      </div>
    </template>
    <v-col
      cols="12"
      class="px-0"
    >
      <v-divider />
    </v-col>
    <div
      style="height: 21px; width: 100%; position: relative;"
    >
      <v-icon
        v-show="subIcon"
        :color="subIconColor"
        size="20"
        class="mx-2"
      >
        {{ subIcon }}
      </v-icon>

      <div
        v-show="subText && subTextClick"
        :style="`
          color: ${subTextColor};
          margin: auto;
          cursor: pointer;
          text-align: center;
          width: 100%;
        `"
        class="font-weight-light"
        @click="subTextClick()"
        v-text="subText"
      />
    </div>
  </base-material-card>
</template>

<script>
  import Card from './Card'

  export default {
    name: 'MaterialStatsCardCustom',

    inheritAttrs: false,

    props: {
      ...Card.props,
      icon: {
        type: String,
        required: true,
      },
      subIcon: {
        type: String,
        default: undefined,
      },
      subIconColor: {
        type: String,
        default: undefined,
      },
      subTextColor: {
        type: String,
        default: undefined,
      },
      subText: {
        type: String,
        default: undefined,
      },
      subTextClick: {
        type: Function,
        default: undefined,
      },
      title: {
        type: String,
        default: undefined,
      },
      value: {
        type: String,
        default: undefined,
      },
      valueSize: {
        type: String,
        default: undefined,
      },
      valueColor: {
        type: String,
        default: undefined,
      },
      valueWeight: {
        type: String,
        default: undefined,
      },
      smallValue: {
        type: String,
        default: undefined,
      },
    },
  }
</script>

<style lang="sass">
.v-card--material-stats
  display: flex
  flex-wrap: wrap
  position: relative

  > div:first-child
    justify-content: space-between

  .v-card
    border-radius: 4px
    flex: 0 1 auto

  .v-card__text
    display: inline-block
    flex: 1 0 calc(100% - 120px)
    position: absolute
    top: 0
    right: 0
    width: 100%

  .v-card__actions
    flex: 1 0 100%
  &.jp-card
    display: flex
    flex-direction: column
    justify-content: space-between
    .v-card--material__heading
      padding: 16px!important
      .v-icon
        font-size: 40px!important
    .jp-value-text
      word-wrap: break-word!important
      word-break: break-all!important
    .d-flex.grow.flex-wrap
      width: 100%!important
      position: relative
      div.ml-6
        margin-left: auto!important
        padding-left: 12px !important
</style>
